module.exports = __webpack_public_path__ + "e2b25e11.png";